import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { SacredGeometry } from "./SacredGeometry";

const MaskedLine = ({ children, delay }) => (
  <div className="overflow-hidden">
    <motion.div
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.15, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  </div>
);

export const Hero = () => {
  const { scrollYProgress } = useScroll();
  const monoY = useTransform(scrollYProgress, [0, 0.35], [0, 140]);
  const monoR = useTransform(scrollYProgress, [0, 0.35], [0, 10]);

  return (
    <section id="top" data-testid="hero-section"
      className="relative min-h-screen bg-royal overflow-hidden flex flex-col justify-center">
      <SacredGeometry variant="flower" className="left-[-5rem] bottom-[-4rem] w-80 opacity-20" />
      <motion.div style={{ y: monoY, rotate: monoR }}
        className="absolute -right-10 md:right-6 top-1/2 -translate-y-1/2 w-[55vw] md:w-[34vw] max-w-[480px] opacity-40 md:opacity-90 pointer-events-none">
        <motion.img
          src="/rck-monogram.png"
          alt="RCK monogram"
          data-testid="hero-monogram"
          initial={{ opacity: 0, scale: 1.15 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.6, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="w-full mix-blend-screen"
        />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full pt-24">
        <MaskedLine delay={0.35}>
          <p className="eyebrow text-gold mb-8" data-testid="hero-eyebrow">
            Future-maker · Alchemist · Systems Thinker
          </p>
        </MaskedLine>
        <h1 className="font-display font-light text-cream leading-[0.92] text-[17vw] md:text-[10.5vw]">
          <MaskedLine delay={0.5}><span data-testid="hero-name-1">Rachelle</span></MaskedLine>
          <MaskedLine delay={0.62}><span data-testid="hero-name-2" className="italic text-gold">Cooper</span></MaskedLine>
          <MaskedLine delay={0.74}><span data-testid="hero-name-3">Kulkarni</span></MaskedLine>
        </h1>
        <div className="mt-12 md:mt-16 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <MaskedLine delay={1.0}>
            <p className="max-w-md text-cream/80 text-base leading-relaxed" data-testid="hero-intro">
              Creating thriving futures — changing insights into impact, translating complex
              challenges into impactful change and balanced systems.
            </p>
          </MaskedLine>
          <MaskedLine delay={1.15}>
            <a href="#about" data-testid="hero-scroll-cue"
              className="inline-flex items-center gap-3 eyebrow text-cream/70 hover:text-gold transition-colors duration-300">
              Begin the journey <ArrowDown size={14} className="animate-bounce" />
            </a>
          </MaskedLine>
        </div>
      </div>
    </section>
  );
};
